import DOMPurify from 'dompurify';
import { renderMarkdown } from '../../utils/markdown.js';

// renderMarkdown escapes its input; DOMPurify is the second layer.
export default function Markdown({ text, className = '' }) {
  const html = DOMPurify.sanitize(renderMarkdown(text), { ADD_ATTR: ['target'] });
  return <div className={`md-text ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
